import moment from 'moment';
import { each, some, isNil } from 'lodash';
import { isValidNumber } from 'libphonenumber-js';

export const validateDate = (rule, value, callback) => {
  const isValid = moment(value).isValid();
  if (isValid) return callback();
  return callback(new Error());
};


export const checkEmailRFC822 = (email) => {
  const sQtext = '[^\\x0d\\x22\\x5c\\x80-\\xff]';
  const sDtext = '[^\\x0d\\x5b-\\x5d\\x80-\\xff]';
  const sAtom = '[^\\x00-\\x20\\x22\\x28\\x29\\x2c\\x2e\\x3a-\\x3c\\x3e\\x40\\x5b-\\x5d\\x7f-\\xff]+';
  const sQuotedPair = '\\x5c[\\x00-\\x7f]';
  const sDomainLiteral = `\\x5b(${sDtext}|${sQuotedPair})*\\x5d`;
  const sQuotedString = `\\x22(${sQtext}|${sQuotedPair})*\\x22`;
  const sDomainRef = sAtom;
  const sSubDomain = `(${sDomainRef}|${sDomainLiteral})`;
  const sWord = `(${sAtom}|${sQuotedString})`;
  const sDomain = `${sSubDomain}(\\x2e${sSubDomain})*`;
  const sLocalPart = `${sWord}(\\x2e${sWord})*`;
  const sAddrSpec = `${sLocalPart}\\x40${sDomain}`; // complete RFC822 email address spec
  const sValidEmail = `^${sAddrSpec}$`; // as whole string

  const reValidEmail = new RegExp(sValidEmail);

  console.log('in checkEmailRFC822', email);

  return reValidEmail.test(email);
};

export const validateEmailRFC822 = (value) => {
  let invalid = 0;

  if (value && value !== '') {
    // remove all control characters
    value = value.replace(/[\n\r\t]/g, '');

    // console.log('gate 1', value);
    // email list with names separated by coma e.g. John Doe <john.doe@example.com>, John Doe <john.doe@example.com>
    if (value.indexOf(',') !== -1) {
      const list = value.split(',');
      each(list, (item) => {
        if (item && item.trim() !== '' && item.indexOf('<') !== -1) {
          const tmp = item.split('<');

          console.log('tmp', tmp);

          const name = tmp[0] ? tmp[0].trim() : null;
          const email = tmp[1].replace(/>/g, '').trim();
          const isValid = name && checkEmailRFC822(email);

          if (!isValid) invalid += 1;
        }
      });
    } else {
      const isValid = checkEmailRFC822(value);
      if (!isValid) invalid += 1;
      // console.log('gate 2', isValid);
    }
  }
  // console.log('validateEmailRFC822', value, invalid);
  return invalid === 0;
};

export const checkRestrictedSubdomain = (subdomain) => {
  const valid = /^[a-z0-9][a-z0-9-]{1,61}[a-z0-9]$/.test(subdomain);
  const reserved = some([/^dc-.*/, /diet-creator|dietcreator|nuttrema/], regex => regex.test(subdomain));
  return valid && !reserved;
};

export const validatePhoneE164 = value => (isNil(value) || value === '') || isValidNumber(value);



// WEBPACK FOOTER //
// ./src/helpers/validation-helper.js